interface PromoPriceProps {
  regular: string;
  promo?: string;
  size?: string;
}

export function PromoPrice({ regular, promo, size = 'text-xl' }: PromoPriceProps) {
  return promo ? (
    <>
      {/* Small gap so the struck-through "was" price isn't cramped against the promo price. */}
      <p className="text-sm text-red line-through leading-none mb-1">{regular}</p>
      <p className={`${size} font-bold text-secondary leading-none mb-0`}>{promo}</p>
    </>
  ) : (
    <p className={`${size} font-bold text-secondary leading-none mb-0`}>{regular}</p>
  );
}
